import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AUTH_EVENT, getActiveSession } from "../utils/nightStayAccount";
import {
  clearUserBookings,
  loadUserBookings,
  selectUserBookingsStatus,
} from "../store";

const deriveIdentity = (session) => {
  const email = typeof session?.email === "string" ? session.email.trim() : "";
  const phone = typeof session?.phone === "string" ? session.phone.trim() : "";
  const key = `${email}|${phone}`;
  return { email, phone, key };
};

function UserBookingsBootstrapper() {
  const dispatch = useDispatch();
  const bookingsStatus = useSelector(selectUserBookingsStatus);
  const statusRef = useRef(bookingsStatus);
  const lastKeyRef = useRef("");

  useEffect(() => {
    statusRef.current = bookingsStatus;
  }, [bookingsStatus]);

  useEffect(() => {
    const syncUserBookings = () => {
      const session = getActiveSession();
      const { email, phone, key } = deriveIdentity(session);
      if (!email && !phone) {
        lastKeyRef.current = "";
        dispatch(clearUserBookings());
        return;
      }
      if (lastKeyRef.current === key && statusRef.current === "succeeded") return;
      lastKeyRef.current = key;
      dispatch(loadUserBookings({ email, phone }));
    };

    syncUserBookings();
    if (typeof window !== "undefined") {
      window.addEventListener(AUTH_EVENT, syncUserBookings);
    }
    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener(AUTH_EVENT, syncUserBookings);
      }
    };
  }, [dispatch]);

  return null;
}

export default UserBookingsBootstrapper;
